import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22.076}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32233 37526"
    {...props}
  >
    <path
      d="m18116 25766 8747-7271h5008L26943 0H5258L329 18495h5041l8744 7271L0 37502l3973 24 10648-8854v8657h2957l1-8684 10678 8881 3976-24-14117-11736zm-8744-7271h5249v4363l-5249-4363zm8206 4390v-4390h5283l-5281 4389-2 1z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
